import { render, staticRenderFns } from "./OrderPreviewModal.vue?vue&type=template&id=41766648"
import script from "./OrderPreviewModal.vue?vue&type=script&lang=ts"
export * from "./OrderPreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports